import { redirect } from 'redux-first-router';
import { WATCH } from 'app-source/routes/types';
import { actions } from 'app-webtech-core';

export const sectionSelect = (dispatch, type) => {
  dispatch(redirect({ type }));
  dispatch(actions.layout.sectionSelect({ section: type === WATCH ? 'live' : 'vod' }));
};
